module.exports = __webpack_public_path__ + "static/media/social-image.28e23607.jpg";